<template>
  <!-- Visor de archivos: PDF página a página e imágenes; el resto, opción de descargar -->
  <v-dialog :value="abierto" max-width="1000" scrollable @input="(v) => !v && cerrar()">
    <v-card class="rounded-xl visor-adjunto">
      <v-toolbar flat dense color="grey lighten-4">
        <v-icon left small color="primary">{{ tipo === 'image' ? 'mdi-image-outline' : 'mdi-file-pdf-box' }}</v-icon>
        <v-toolbar-title class="subtitle-1 font-weight-bold text-truncate">{{ item && item.name }}</v-toolbar-title>
        <v-spacer />
        <v-btn text small color="primary" class="text-none" :disabled="!blob" @click="descargar">
          <v-icon left small>mdi-download</v-icon> Descargar
        </v-btn>
        <v-btn icon small aria-label="Cerrar visor" @click="cerrar"><v-icon small>mdi-close</v-icon></v-btn>
      </v-toolbar>

      <v-card-text class="pa-0 visor-cuerpo">
        <div v-if="cargando" class="d-flex flex-column align-center justify-center pa-12 grey--text">
          <v-progress-circular indeterminate color="primary" class="mb-3" />
          Cargando…
        </div>
        <div v-else-if="error" class="text-center pa-12 grey--text text--darken-1">
          <v-icon size="48" color="error lighten-1">mdi-alert-circle-outline</v-icon>
          <p class="mt-3 mb-0">{{ error }}</p>
        </div>
        <div v-show="!cargando && !error && tipo === 'pdf'" ref="pdfContainer" class="visor-pdf"></div>
        <div v-if="!cargando && !error && tipo === 'image'" class="d-flex justify-center pa-4">
          <img :src="urlImagen" :alt="item && item.name" class="visor-imagen" />
        </div>
        <div v-if="!cargando && !error && tipo === 'otro'" class="text-center pa-12 grey--text text--darken-1">
          <v-icon size="48" color="grey lighten-1">mdi-file-eye-outline</v-icon>
          <p class="mt-3">Este tipo de archivo no tiene vista previa.</p>
          <v-btn color="primary" depressed class="text-none" @click="descargar">
            <v-icon left>mdi-download</v-icon> Descargar
          </v-btn>
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import * as pdfjsLib from "pdfjs-dist";
import pdfjsWorker from "pdfjs-dist/build/pdf.worker.js";
import { tipoDe, guardarArchivo } from "@/utils/archivos";

pdfjsLib.GlobalWorkerOptions.workerSrc = pdfjsWorker;

// Uso: this.$refs.visor.abrir(item, () => blobDelArchivo)
export default {
  name: "VisorArchivo",
  data() {
    return { abierto: false, item: null, blob: null, tipo: "", urlImagen: "", cargando: false, error: "", turno: 0 };
  },
  beforeDestroy() {
    this.cerrar();
  },
  methods: {
    async abrir(item, obtenerBlob) {
      this.cerrar();
      const turno = ++this.turno;
      Object.assign(this, { abierto: true, item, cargando: true });
      try {
        const blob = await obtenerBlob();
        if (turno !== this.turno) return; // se abrió otro mientras tanto
        this.blob = blob;
        this.tipo = await tipoDe(blob, item);
        if (this.tipo === "image") this.urlImagen = URL.createObjectURL(blob);
        this.cargando = false;
        if (this.tipo === "pdf") {
          await this.$nextTick();
          await this.renderPdf(await blob.arrayBuffer());
        }
      } catch (e) {
        console.error("Error al previsualizar el archivo:", e);
        if (turno !== this.turno) return;
        this.cargando = false;
        this.error = "No se pudo cargar el archivo.";
      }
    },
    descargar() {
      guardarArchivo(this.item, this.blob);
    },
    cerrar() {
      this.turno++;
      if (this.urlImagen) URL.revokeObjectURL(this.urlImagen);
      if (this.$refs.pdfContainer) this.$refs.pdfContainer.innerHTML = "";
      Object.assign(this, { abierto: false, item: null, blob: null, tipo: "", urlImagen: "", cargando: false, error: "" });
    },
    async renderPdf(datos) {
      const pdf = await pdfjsLib.getDocument({ data: datos }).promise;
      const contenedor = this.$refs.pdfContainer;
      if (!contenedor) return;
      contenedor.innerHTML = "";
      const ancho = contenedor.clientWidth;
      const densidad = window.devicePixelRatio || 1;

      for (let n = 1; n <= pdf.numPages; n++) {
        const pagina = await pdf.getPage(n);
        const base = pagina.getViewport({ scale: 1 });
        const viewport = pagina.getViewport({ scale: (ancho / base.width) * densidad });
        const canvas = document.createElement("canvas");
        canvas.className = "visor-pagina";
        canvas.width = viewport.width;
        canvas.height = viewport.height;
        canvas.style.width = `${viewport.width / densidad}px`;
        contenedor.appendChild(canvas);
        await pagina.render({ canvasContext: canvas.getContext("2d"), viewport }).promise;
      }
    },
  },
};
</script>

<style scoped>
.visor-cuerpo {
  max-height: 78vh;
  background: #eef1f4;
}
.visor-pdf {
  padding: 16px;
}
/* las páginas las crea pdf.js (sin el atributo del componente): selector profundo */
.visor-pdf >>> .visor-pagina {
  display: block;
  margin: 0 auto 16px;
  max-width: 100%;
  background: white;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.18);
}
.visor-imagen {
  max-width: 100%;
  max-height: 70vh;
  object-fit: contain;
  background: white;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.18);
}
</style>
